export default "__VITE_ASSET__192a63e6__"